import { Component, Input, EventEmitter, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'view-image-button',
    templateUrl: './view-image-button.component.html',
    styleUrls: ['./view-image-button.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class ViewImageButtonTableComponent {
    /** every photo of the record, already resolvable by the browser */
    @Input() images: string[] = [];
    @Output() viewEvent = new EventEmitter<string[]>();

    viewRoute() {
        this.viewEvent.emit(this.images);
    }

}
